// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingSwitch":"bhm_a bib_ea bib_a","LoadingSwitch__init":"bhm_b bib_a bib_w bib_j bib_ul bib_um bib_fm"};